import type { ChangeEvent } from 'react';

import { fieldStyle } from '../venueCreateFields';

interface TextareaProps {
  value: string;
  onChange: (v: string) => void;
  rows?: number;
  id?: string;
  maxLength?: number;
  placeholder?: string;
  /** Id of the element that explains this field, read out with it. */
  describedBy?: string;
}

/** Controlled multi-line input for the venue detail-page edit sections. */
export function Textarea({
  value,
  onChange,
  rows = 2,
  id,
  maxLength,
  placeholder,
  describedBy,
}: TextareaProps) {
  return (
    <textarea
      id={id}
      value={value}
      rows={rows}
      maxLength={maxLength}
      placeholder={placeholder}
      aria-describedby={describedBy}
      onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
      style={fieldStyle(undefined, {
        height: 'auto',
        padding: '8px 10px',
        resize: 'vertical',
        lineHeight: 1.5,
      })}
    />
  );
}
